import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ModalController } from '@ionic/angular';
import { finalize, Observable, take } from 'rxjs';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
import { DateUtilsService } from 'src/app/modules/services/date-utils/date-utils.service';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { highwayI } from './../../../@types/hightway.interface';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';
import { PerformanceParameterService } from 'src/app/modules/services/performanceParameter/performance-parameter.service';
import { DocumentosService } from 'src/app/modules/services/documentos/documentos.service';
import { IntervenientesService } from 'src/app/modules/services/intervenientes/intervenientes.service';
import { AnotacoesService } from 'src/app/modules/services/anotacoes/anotacoes.service';
import { RepresentanteLegalService } from 'src/app/modules/services/representante-legal/representante-legal.service';
import { ServicosIniciaisService } from 'src/app/modules/services/servicos-iniciais/servicos-iniciais.service';
import { AmpliacaoService } from 'src/app/modules/services/ampliacao/ampliacao.service';
import { RelatoriosOperacionaisService } from 'src/app/modules/services/relatorios-operacionais/relatorios-operacionais.service';
import { RelatoriosContratuaisService } from 'src/app/modules/services/relatorios-contratuais/relatorios-contratuais.service';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { FeriadoService } from 'src/app/modules/services/feriado/feriado.service';
import { NotificacaoContratoService } from 'src/app/modules/services/notificacao-contrato/notificacao-contrato.service';

@Component({
  selector: 'app-modal-historic',
  templateUrl: './modal-historic.component.html',
  styleUrls: ['./modal-historic.component.scss']
})
export class ModalHistoricComponent implements OnInit {
 
  @Input() fieldMappings!: { [key: string]: string };
  @Input() data: any;

  dataSource = new MatTableDataSource<any>([]);
  
  // Declaração de todas as propriedades de ID
  id!: string | null;
  highwayId!: string | null;
  segmentId!: string | null;
  documentId!: string | null;
  entitieId!: string | null;
  adressId!: string | null;
  contracId!: string | null;
  projectId!: string | null;
  disciplinaId!: string | null;
  type!: string;

  pageSize = 10;
  pageIndex = 0;
  totalElements = 0;
  totalPages = 0;

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  private serviceMap!: { [key: string]: () => Observable<any> };

  constructor(
    private entitieService: EntitiesService,
    private contractService: ContractService,
    private snackbarService: OpenSnackbarService,
    private dateUtils: DateUtilsService,
    private loadingService: LoadingService,
    private modalCtrl: ModalController,
    private highWayService: HighwaysService,
    private performanceParameterService: PerformanceParameterService,
    private documentServices: DocumentosService,
    private intervienteService: IntervenientesService,
    private annotationService: AnotacoesService,
    private representanteLegalService: RepresentanteLegalService,
    private servicosIniciaisService: ServicosIniciaisService,
    private ampliacaoService: AmpliacaoService,
    private relatoriosOperacionaisService: RelatoriosOperacionaisService,
    private relatoriosContratuaisService: RelatoriosContratuaisService,
    private projetosService: ProjetosService,
    private feriadoService: FeriadoService,
    private notificacaoContratoService: NotificacaoContratoService,

  ) {}

  ngOnInit(): void {
    this.type = this.data?.type;
    this.id = this.data?.id
    this.highwayId = this.data?.highwayId;
    this.segmentId = this.data?.segmentId;
    this.documentId = this.data?.documentId?.id;
    this.entitieId = this.data?.entitieId;
    this.adressId = this.data?.adressId;
    this.contracId = this.data?.contracId;
    this.projectId = this.data?.projectId;
    this.disciplinaId = this.data?.disciplinaId;

    // Atribui todas as propriedades de forma limpa e direta
    
    // Mapeamento de serviços usando as propriedades do componente
    this.serviceMap = {
      "entitie": () => this.entitieService.getHistoryEntitie(this.id, this.pageIndex),
      "contract": () => this.contractService.getHistoryContract(this.id, this.pageIndex),
      "rodovia": () => this.highWayService.getHistoryRodovias(this.id, this.highwayId, this.pageIndex),
      "parametro": () => this.performanceParameterService.getHistoryParameter(this.id, this.segmentId, this.pageIndex),
      "documento": () => this.documentServices.getHistoryDocument(this.id, this.documentId, this.pageIndex),
      "interveniente": () => this.intervienteService.getHistoryInterveniente(this.id, this.entitieId, this.pageIndex),
      "anotacao": () => this.annotationService.getHistoryAnotacao(this.id, this.entitieId, this.pageIndex),
      "enderecoEntidade": () => this.entitieService.getHistoryEndereco(this.adressId, this.pageIndex),
      "dadosBancarios": () => this.entitieService.getHistoryDadosBancarios(this.id, this.pageIndex),
      "representante": () => this.representanteLegalService.getHistorico(this.id, this.pageIndex),
      "servicoInicial": () => this.servicosIniciaisService.getHistorico(this.id, this.contracId, this.pageIndex),
      "servicoAmpliacao": () => this.ampliacaoService.getHistorico(this.id, this.contracId, this.pageIndex),
      "relatorioOperacional": () => this.relatoriosOperacionaisService.getHistorico(this.id, this.contracId, this.pageIndex),
      "relatorioContratual": () => this.relatoriosContratuaisService.getHistorico(this.id, this.contracId, this.pageIndex),
      "projetos": () => this.projetosService.getHistorico(this.id, this.contracId, this.pageIndex),
      "feriados": () => this.feriadoService.getHistorico(this.id, this.pageIndex),
      "notificacoes": () => this.notificacaoContratoService.getHistorico(this.id, this.pageIndex),
      'analiseProjeto': () => this.projetosService.getHistoricoAnalise(this.projectId, this.id,  this.pageIndex),
      'analiseDisciplina': () => this.projetosService.getHistoricoAnaliseDisciplina(this.projectId, this.disciplinaId, this.id, this.pageIndex),
      'prazoAnaliseProjeto': () => this.contractService.getHistoryPrazoAnaliseProjeto(this.id, this.pageIndex),
      'disciplinaProjeto': () => this.projetosService.getHistoricoDisciplina(this.projectId!, this.id!, this.pageIndex),
    };

    this.loadHistorics();
  }

  loadHistorics(): void {
    const serviceFunction = this.serviceMap[this.type];
    if (serviceFunction) {
      this.genericGetHistory(serviceFunction);
    } else {
      console.warn("Tipo desconhecido:", this.type);
    }
  }

  private genericGetHistory(serviceCall: () => Observable<any>): void {
    this.loadingService.showLoading();
    serviceCall()
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          this.updateTableData(res);
        },
        error: (err: any) => {
          this.snackbarService.openSnackBar(err.error.message, 'error');
        }
      });
  }

  private updateTableData(res: any): void {
    const { content, pageSize, totalPages, totalElements, pageNumber } = res;
    this.dataSource.data = content;
    this.pageSize = pageSize;
    this.totalPages = totalPages;
    this.totalElements = totalElements;
    this.pageIndex = pageNumber;
  }

  formatField(field: string): string {
    return this.fieldMappings[field] || field;
  }

  pageChangeEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadHistorics();
  }

  formatDateToReadable(isoDate: string): string {
    return this.dateUtils.formatDateToReadable(isoDate);
  }

  cancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'confirm');
  }

  checkIncludesAny(valor: string, termos: string[]): boolean {
    return termos.some(termo => valor.includes(termo));
  }
}
export interface Historic {
  date: Date;
}

export const mockHistorics: Historic[] = [
  { date: new Date('2023-10-01T14:30:00') },
  { date: new Date('2023-10-10T10:45:00') },
  { date: new Date('2023-10-20T09:00:00') }
];